<kno2-dialog-body>
    <div class="container-fluid p-0">
        @if (error()) {
            <kno2-notification-alert
                type="danger"
                [title]="error()"
                (dismiss)="error.set(null)"></kno2-notification-alert>
        }

        <p class="mb-4">
            As part of the identity verification process, our partner
            <strong>CLEAR</strong>
            has returned the following information:
        </p>

        <div class="bg-light mb-4">
            <div class="card-body py-3">
                <div class="row">
                    <div class="col-md-4">
                        <div class="d-flex flex-column">
                            <small
                                class="text-muted mb-1"
                                style="font-size: 0.75rem; letter-spacing: 0.5px">
                                FIRST NAME
                            </small>
                            @if (isLoading()) {
                                <div
                                    class="spinner-border spinner-border-sm"
                                    role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            } @else {
                                {{ verificationSession()?.user?.firstName }}
                            }
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="d-flex flex-column">
                            <small
                                class="text-muted mb-1"
                                style="font-size: 0.75rem; letter-spacing: 0.5px">
                                LAST NAME
                            </small>
                            @if (isLoading()) {
                                <div
                                    class="spinner-border spinner-border-sm"
                                    role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            } @else {
                                {{ verificationSession()?.user?.lastName }}
                            }
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="d-flex flex-column">
                            <small
                                class="text-muted mb-1"
                                style="font-size: 0.75rem; letter-spacing: 0.5px">
                                DATE OF BIRTH
                            </small>
                            @if (isLoading()) {
                                <div
                                    class="spinner-border spinner-border-sm"
                                    role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            } @else {
                                {{ verificationSession()?.user?.dateOfBirth | date: "M/d/yyyy" }}
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <p class="mb-4">
            Please review the information above to ensure it is accurate and pertains to you. This information is shown only for assertion of identity, no
            personal information from
            <strong>CLEAR</strong>
            will be retained.
        </p>

        <p class="mb-4">
            If the information is incorrect or does not pertain to you, please email
            <strong>{{ brandDisplayName() }}</strong>
            support and include this id for reference
            <strong>{{ verificationSession()?.id }}</strong>
            and a member of our team will contact you to resolve the matter.
        </p>

        <div
            class="border rounded p-3"
            style="background-color: #fafafa">
            <div class="form-check d-flex align-items-start">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="confirmInfo"
                    name="agree"
                    [(ngModel)]="isConfirmed" />
                <label
                    class="form-check-label ms-2"
                    for="confirmInfo">
                    <strong>I confirm that the information shown above is accurate and pertains to me.</strong>
                </label>
            </div>
        </div>
    </div>
</kno2-dialog-body>

<kno2-dialog-footer>
    <div class="d-flex justify-content-end gap-2">
        <button
            type="button"
            class="btn btn-primary px-4"
            [disabled]="!isConfirmed() || isLoading() || isSubmitting() || error()"
            (click)="confirm()">
            @if (isSubmitting()) {
                <span class="spinner-border spinner-border-sm"></span>
            }
            <span class="ladda-label">Confirm</span>
        </button>
    </div>
</kno2-dialog-footer>
